import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'
import { Box } from '@mantine/core'
import { AppButton } from '../../app/common/ui'
import { RegistryGridSkeleton } from '@gunslop/ui'
import { useStore } from '../../app/stores/store'
import RegistryModelCard from './RegistryModelCard'
import { EmptyState } from '../../app/common/ui'

export default observer(function RegistryList () {
  const history = useHistory()
  const { firearmModelStore } = useStore()
  const {
    modelsByDate,
    loadingInitial,
    loading,
    loadModels,
    totalCount,
    pageNumber,
    viewError
  } = firearmModelStore

  const hasMore = modelsByDate.length < totalCount
  const handleLoadMore = () => {
    firearmModelStore.pageNumber = pageNumber + 1
    loadModels(true)
  }

  if (viewError) {
    return (
      <Box sx={{ padding: 'var(--gs-lg)', textAlign: 'center' }}>
        <Box sx={{ color: 'var(--gs-muted)', marginBottom: 'var(--gs-sm)' }}>{viewError}</Box>
        {viewError.includes('log in') && (
          <AppButton component="a" href="/blog" variant="light">
            Go to log in
          </AppButton>
        )}
      </Box>
    )
  }

  if (loadingInitial) {
    return <RegistryGridSkeleton count={6} />
  }

  if (modelsByDate.length === 0) {
    return (
      <Box sx={{ padding: '16px 24px' }}>
        <EmptyState
          title="No firearms found"
          message="Try different filters or be the first to submit this model."
          action={{
            label: '+ Submit a Model',
            onClick: () => history.push('/registry/new')
          }}
        />
      </Box>
    )
  }

  return (
    <>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: 12,
          padding: '16px 24px',
          '@media (max-width: 639px)': { gridTemplateColumns: '1fr' },
          '@media (min-width: 640px) and (max-width: 1023px)': { gridTemplateColumns: 'repeat(2, 1fr)' }
        }}
      >
        {modelsByDate.map((model) => (
          <RegistryModelCard key={model.id} model={model} />
        ))}
        {/* Dashed submit card */}
        <Box
          component="button"
          type="button"
          onClick={() => history.push('/registry/new')}
          sx={{
            background: 'var(--gs-surface)',
            border: '1.5px dashed #484F58',
            borderRadius: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 180,
            cursor: 'pointer',
            transition: 'border-color 150ms',
            '&:hover': { borderColor: '#E85D04' }
          }}
        >
          <Box sx={{ fontSize: 32, color: '#484F58', marginBottom: 8 }}>+</Box>
          <Box sx={{ fontFamily: 'DM Sans, sans-serif', fontSize: 12, fontWeight: 600, color: '#8B949E' }}>
            Submit a Model
          </Box>
          <Box sx={{ fontFamily: 'DM Sans, sans-serif', fontSize: 10, color: '#8B949E' }}>
            Help grow the registry
          </Box>
        </Box>
      </Box>
      {hasMore && (
        <AppButton
          fullWidth
          variant="outline"
          loading={loading}
          onClick={handleLoadMore}
          sx={{
            margin: '0 var(--gs-md) var(--gs-lg)',
            background: '#21262D',
            border: '1.5px solid #484F58',
            color: '#E6EDF3',
            '&:hover': { background: '#30363D', color: '#E6EDF3' }
          }}
        >
          Load more
        </AppButton>
      )}
    </>
  )
})
